import React, { useState } from 'react';
import { v4 as uuidV4 } from 'uuid';
import ReactApexChart from 'react-apexcharts';

interface LineChartI {
  mode?: 'dark' | 'light';
  title?: string;
  titlePos?: 'left' | 'right' | 'center';
  type: any;
  stacked?: boolean;
  width?: number;
  height?: number;
  datalabel?: boolean;
  sparkline?: boolean;
  monochrome?: string;
  donut?: {
    donutShowTotal?: boolean;
  };
  legend?: boolean;
  legendPos?: string;
  series: [];
  labels?: [];
  xAxis?: any;
  yAxis?: any;
  plotOptions?: any;
}

function LineChart(props: LineChartI) {
  const {
    mode,
    title,
    type,
    stacked,
    width,
    height,
    datalabel,
    titlePos,
    donut: donutConfig,
    sparkline,
    monochrome,
    legend,
    legendPos,
    labels,
    series,
    xAxis,
    yAxis,
    plotOptions,
  } = props;
  const [key, setKey] = useState<string>('apexChart' + uuidV4());
  return (
    <div>
      <ReactApexChart
        key={key}
        type={type}
        width={width || undefined}
        height={height || undefined}
        options={{
          // colors: [
          //   '#2f9aa7',
          //   '#6fb1cf',
          //   '#acc7ec',
          //   '#e2deff',
          //   '#e0afe3',
          //   '#e879ab',
          //   '#de425b',
          // ],
          // colors: ['#e93d27', '#f16242', '#f7805f', '#fc9c7e', '#feb79e'],
          chart: {
            stacked: stacked,
            zoom: {
              enabled: false,
            },
            sparkline: {
              enabled: sparkline,
            },
          },
          theme: {
            mode: mode,
            monochrome: monochrome
              ? {
                  enabled: true,
                  color: monochrome, //'#2f9aa7', //'#ef472d',
                  shadeTo: mode,
                }
              : {},
            palette: 'palette3',
          },
          dataLabels: {
            enabled: datalabel,
          },
          plotOptions: {
            ...(plotOptions ? plotOptions : {}),
            //this is used to show center total in donut chart
            ...(donutConfig?.donutShowTotal
              ? {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        total: {
                          show: true,
                        },
                      },
                    },
                  },
                }
              : {}),
          },
          title: {
            text: title,
            align: titlePos,
          },
          labels: labels || [],
          legend: {
            show: legend,
            ...(legendPos ? { position: legendPos } : ({} as any)),
          },
          xaxis: xAxis || {},
          yaxis: yAxis || {},
        }}
        series={series}
      />
    </div>
  );
}

export { LineChart };
